import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const UsersPage = lazy(() =>
  import("@/admin/pages/UsersPage").then((m) => ({ default: m.UsersPage })),
);

export const Route = createFileRoute("/admin/users")({
  component: () => (
    <Suspense fallback={null}>
      <UsersPage />
    </Suspense>
  ),
});
